import { parseHubSource } from "src/utils/hubSource";

/**
 * Entertainment hub data source: `ers` (legacy) or `payload` (pg-payload-cms).
 * @returns {'ers' | 'payload'}
 */
export function getEntertainmentSource() {
  return parseHubSource(process.env.REACT_APP_ENTERTAINMENT_SOURCE);
}

export function isPayloadEntertainmentSource() {
  return getEntertainmentSource() === "payload";
}
